var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.554223,399.380023 L351.076806,395.857436 C351.401065,395.533178 351.401065,395.007452 351.076806,394.68324 C350.752548,394.358982 350.22687,394.358982 349.902612,394.68324 L346.379983,398.205874 L342.857353,394.683194 C342.533095,394.358935 342.007417,394.358935 341.683159,394.683194 C341.358947,395.007452 341.358947,395.533178 341.683159,395.85739 L345.205788,399.379977 L341.683159,402.90261 C341.358947,403.226869 341.358947,403.752594 341.683159,404.076806 C342.007417,404.401065 342.533095,404.401065 342.857353,404.076806 L346.379983,400.554173 L349.902612,404.076806 C350.226824,404.401065 350.752548,404.401065 351.076806,404.076806 C351.401065,403.752548 351.401065,403.226869 351.076806,402.90261 L347.554223,399.380023 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Edit-Profile--General-Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-profile---General-details",
    transform: "translate(-339.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icAddBlack",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(346.380000, 399.380000) rotate(-44.000000) translate(-346.380000, -399.380000) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddBlack);
export default __webpack_public_path__ + "static/media/icAddBlack.6617a238e7c0d47cb3e0c99c0f672b48.svg";
export { ForwardRef as ReactComponent };